import React, { useState,useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../components/pages/Home';
import Video from '../components/pages/Video';
import BodyWeightCalculator from '../components/pages/BodyWeightCalculator';
import TermsCondition from '../components/pages/TermsCondintion';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {GETUSER} from '../services/api';
import AvatarChatbot from '../components/pages/AvatarChatbot';
import WorkoutPlan from './pages/WorkoutPlan';

function AppWrapper(props) {
  const [user_id,setUserId]= useState('');
  const aiDemo = props.hostname === "aidemo";


  useEffect(() => {
 
    const queryParams = new URLSearchParams(window.location.search);
    const userIdFromParams = queryParams.get("user_public_id");
    const m = queryParams.get("m");
    const operator = localStorage.getItem("currentOperator");
    const operatorDemos = ["DEMO","OOREDOO_ALGERIA"];
    const isOperator = operatorDemos.includes(operator);

    const getUser = async () => {
        const response = await GETUSER(userIdFromParams);
        if(response.data.status == "SUCCESS"){
          if(response.data.payload.subscription.status == "SUBSCRIBER"){
            localStorage.setItem("user_public_id", userIdFromParams);
            localStorage.setItem("subscription_dt",response.data.payload.subscription.subscription_dt)
            setUserId(userIdFromParams);
          }else{
            localStorage.removeItem('user_public_id');
            localStorage.removeItem('subscription_dt');
            setUserId('');
          }
       }else{
          localStorage.removeItem('user_public_id');
          localStorage.removeItem('subscription_dt');
          setUserId('');
       }
    }

    if(m){
      localStorage.setItem("m", m);
    }

    if(isOperator){
      // const storedUserId = "b87eebd76cee48c0a7ad874430ba5936";
      const storedUserId = localStorage.getItem("user_public_id");
      if (storedUserId) {
        setUserId(storedUserId);
      }
    }else{
      getUser()
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home user_id={user_id} setUserId={setUserId} navlinks={true} hostname={props.hostname} />} />
        <Route path="/content/:id" element={<Video user_id={user_id} setUserId={setUserId} hostname={props.hostname}/>} />
        <Route path="/ibw" element={<BodyWeightCalculator user_id={user_id} setUserId={setUserId} hostname={props.hostname}/>} />
        <Route path="/terms&condition" element={<TermsCondition user_id={user_id} setUserId={setUserId} hostname={props.hostname}/>}/>
        {aiDemo && (
          <>
           <Route path="/chatbot" element={<AvatarChatbot user_id={user_id} setUserId={setUserId} hostname={props.hostname}/>}/>
            <Route path="/chatbot/:id" element={<AvatarChatbot user_id={user_id} setUserId={setUserId} hostname={props.hostname}/>}/>
            {/* <Route path="/workoutplan" element={<WorkoutPlan user_id={user_id} setUserId={setUserId} hostname={props.hostname}/>}/> */}
          </>
        )}
      </Routes>
    </Router> 
  );
}

export default AppWrapper;